/// <summary>
/// 上传统计请求网络
/// </summary>

import KitLog from "../KitLog";
import {KitTrack} from "./KitTrack";
import KitAPI from "../KitAPI";
import {KitBehaviour} from "@/Fwk/Kit/KitBehaviour";
import AESHelper from "@/Fwk/Encrypt/AESHelper";
import {MD5Helper} from "@/Fwk/Encrypt/MD5Helper";
import {KitConst} from "../KitConst";
import KitCfg from "../KitCfg";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";
import {JObject} from "@/Fwk/Kit/JObject";
import UtilGzip from "@/Master/UtilGzip";
import Encrypt from "@/Fwk/Encrypt/Encrypt";

/// <author>xiexingwu</author>
export class UploadRequst {
    static URL_PATH = "/service_stats/v3/collect/encrypt"; //统计接口路径
    // static HTTP = "http://";
    static HTTPS = "https://";

    static _uploading = false;
    // static _protocol = true;
    static _startTime: number;

    static _onSuccess: () => void;
    static _onFail: (msg: string) => void;

    public static startTest = false;

    //从数据库获取记录上传
    static Upload(jsonArray: JObject, onSuccess: () => void | null, onFail: (msg: string) => void | null): boolean {
        if (this._uploading) {
            if (KitLog.IsLog) KitTrack.Log("正在上报，本次忽略");
            return false;
        }

        if (KitTrack._isSilent) {
            if (KitLog.IsLog) KitTrack.Log("静默模式，不上报统计数据");
            return false;
        }

        this._onSuccess = onSuccess;
        this._onFail = onFail;
        this._startTime = KitAPI.GetNowSeconds();

        this._uploading = true;
        if (KitLog.IsLog) KitTrack.Log(`打点上传数据加密前:${jsonArray}`);

        KitBehaviour._timer.SetTimer("Upload", () => this.sendRequest(jsonArray), 0, 0);
        return true;
    }

    // private static byte[] GzipCompress(byte[] input)
    // {
    //     using (MemoryStream compressedStream = new MemoryStream())
    //     {
    //         using (GZipStream gzipStream = new GZipStream(compressedStream, CompressionLevel.Optimal))
    //         {
    //             gzipStream.Write(input, 0, input.Length);
    //         }
    //
    //         return compressedStream.ToArray();
    //     }
    // }

    private static async sendRequest(jsonArray: JObject) {
        const curTime = KitAPI.GetNowMills();
        const strStamp = curTime.toString(); // 时间戳
        const aesData = AESHelper.EncryptWeb(JSON.stringify(jsonArray), AESHelper.AES_IV_WEB); // 请求数据AES加密
        // 数据签名，按通讯协议
        const sign = MD5Helper.CreateMD5(`${Encrypt.SIGN_KEY}${aesData}${Encrypt.SIGN_KEY}${strStamp}${Encrypt.SIGN_KEY}`).toLowerCase();
        if (KitLog.IsLog) KitTrack.Log(`打点上传数据加密后:${aesData}`);
        const baseUrl = `${this.HTTPS}${KitCfg.nat_host}`;
        const url = `${this.URL_PATH}?timestamp=${curTime}&encode=gzip&sign=${sign}`;
        if (KitLog.IsLog) KitTrack.Log(`开始上传本地打点数据 url：${url}`);

        // const jsonBytes = new TextEncoder().encode(aesData);
        // const jsonBytesStr = new TextDecoder().decode(jsonBytes);
        const gzipBytes  = UtilGzip.compress(aesData);

        const config: HttpConfig = {
            url: url,
            baseUrl:baseUrl,
            method: 'POST',
            body: gzipBytes,
            encryptionType:'Binary',
            isToken:false,
            timeout: 30000,
            isMergeBody:false,
            headers: {
                'Content-Type': 'application/json',
                'Content-Encoding': 'gzip',
                's-encode-v1': 's0523',
            },
        };

        const response = await this.DoSendRequest<any>(config);
        const responseData = response.data;

        const seconds = (KitAPI.GetNowSeconds() - this._startTime);

        // 等待Task完成，这将异步地等待网络请求完成
        if (response.code == 200) {
            if (KitLog.IsLog) KitTrack.Log(`上传数据统计数据成功，code:${response.code}, 用时:${seconds}s,text:` + responseData);
            this._onSuccess();
        } else {
            if (KitLog.IsLog) KitTrack.Log(`Request->Failed:${baseUrl}, code:${response.code}, 用时:${seconds}s,error:${response.message}`);
            this._onFail(`上传数据失败:${response.message}`);
        }

        this._uploading = false;
    }

    public static async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this._uploading = true;
        const sendRequest = await comRequest<T>(config);
        this._uploading = false;
        return sendRequest;
    }

}